import React from 'react'

const Capicacity = () => {
  return (
    <div>Capicacity</div>
  )
}

export default Capicacity